import { NAVIGATION_PATHS } from "@/const/navigation";
import { safeInternalPath } from "@/lib/utils/navigation-utils";

/**
 * A full page load, so the proxy reads the new session. Without a `redirect`
 * it goes to /auth/mfa on purpose: the proxy forwards from there to wherever
 * the user should be now.
 */
export function continueAfterMfa(searchParams: Pick<URLSearchParams, "get">) {
  window.location.assign(
    safeInternalPath(searchParams.get("redirect")) ?? NAVIGATION_PATHS.Mfa
  );
}

/** `returnTo` is a path and query. */
export function mfaChallengePathReturningTo(returnTo: string) {
  return `${NAVIGATION_PATHS.Mfa}?redirect=${encodeURIComponent(returnTo)}`;
}

/** `returnTo` is a path and query. */
export function mfaSetupPathReturningTo(returnTo: string) {
  return `${NAVIGATION_PATHS.MfaSetup}?redirect=${encodeURIComponent(returnTo)}`;
}
